module.exports = __webpack_public_path__ + "media/images/country_flags/ru-428ae4473c5765f637c294c08b94901d.png";